import styled from 'styled-components';

const ToolBar = styled.div`
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  border-bottom: 1px solid ${(props) => props.theme.lightGrey};
  button {
    color: ${(props) => props.theme.brandPurple};
    margin-bottom: 0;
    background-color: transparent;
    border-left: 1px solid ${(props) => props.theme.lightGrey};
    transition: color 0.5s;
    padding: 20px 30px;
    height: 60px;
  }
`;

export default ToolBar;



// WEBPACK FOOTER //
// ./app/components/Chart/ChartHeader/ToolBar.js